import React from 'react';
import PropTypes from 'prop-types';
import { ENROLLMENT_BULK_ACTION_LIMIT } from 'src/pages/enrollments/constants';
import { useFeatureFlag } from 'common/hooks';
import SelectAllRowsButton from '../../../common/Workqueue/SelectAllRowsButton';
import { BulkAcceptEnrollments } from './BulkAcceptEnrollments';
import { BulkAssignEnrollments } from './BulkAssignEnrollments';

export const EnrollmentBulkActions = ({
 bulkActions, deselectAll, deselectRows, selectedRows,
}) => {
  const disableSubmitRowsButton = selectedRows.length > ENROLLMENT_BULK_ACTION_LIMIT;
  const paysEwqUserAssignment = useFeatureFlag('pays-ewq-user-assignment');

  return (
    <>
      <SelectAllRowsButton
        selectedRows={selectedRows}
        deselectAll={deselectAll}
      />
      {
          bulkActions.map((action) => {
            if (action === 'Accept') {
              return (
                <BulkAcceptEnrollments
                  deselectAll={deselectAll}
                  deselectRows={deselectRows}
                  selectedRows={selectedRows}
                  disableSubmitRowsButton={disableSubmitRowsButton}
                />
              );
            }
            if (action === 'Assign' && paysEwqUserAssignment) {
              return (
                <BulkAssignEnrollments
                  deselectAll={deselectAll}
                  deselectRows={deselectRows}
                  selectedRows={selectedRows}
                  disableSubmitRowsButton={disableSubmitRowsButton}
                />
              );
            }
            return <></>;
          })
        }
    </>
    );
};

EnrollmentBulkActions.propTypes = {
  bulkActions: PropTypes.array.isRequired,
  deselectAll: PropTypes.func.isRequired,
  deselectRows: PropTypes.func.isRequired,
  selectedRows: PropTypes.array.isRequired,
};
